import { useRpc } from "../core/useRpc.js";
export function useCurrentPromotions({
  params,
  options,
  key: _key
} = {}, key) {
  return useRpc(
    "getCurrentPromotions",
    _key ?? key ?? "useCurrentPromotions",
    params,
    {
      getCachedData(key2, nuxtApp) {
        const hydrationData = nuxtApp.isHydrating ? nuxtApp.payload.data[key2] : nuxtApp.static.data[key2];
        return hydrationData ?? nuxtApp._asyncData[key2]?.data.value;
      },
      ...options
    }
  );
}
